var render = function render(){var _vm=this,_c=_vm._self._c;return _c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":_vm.classes,"size":_vm.size,"flip":_vm.flip,"transform":_vm.transform}})
}
var staticRenderFns = []

export { render, staticRenderFns }